import { Asterisk } from "./Reveal";

const ITEMS = [
  "Communication",
  "Independence",
  "Daily Pediatric Programs",
  "Family Collaboration",
  "Generalization",
  "All Ages Welcome",
  "Team-Based Care",
  "Meaningful Progress",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-brand-lightblue/40 bg-white/60 py-7 select-none"
    aria-hidden="true"
  >
    <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="font-serif italic text-2xl md:text-3xl text-brand-blue/80">{item}</span>
          <Asterisk className="h-5 w-5 text-brand-coral/70" />
        </span>
      ))}
    </div>
  </div>
);
